import React from 'react';
import { Edit } from 'react-admin';

import SupplyTypeForm from './SupplyTypeForm';
import ErrorBoundary from '../ErrorBoundary';

const SupplyTypeEdit = props => (
    <ErrorBoundary>
        <Edit {...props} title="Edit Supply Type" undoable={false}>
            <SupplyTypeForm redirect="list" />
        </Edit>
    </ErrorBoundary>
);

export default SupplyTypeEdit;
